import { render, staticRenderFns } from "./WaterworksWriteBody.vue?vue&type=template&id=5aa68108&scoped=true"
import script from "./WaterworksWriteBody.vue?vue&type=script&lang=js"
export * from "./WaterworksWriteBody.vue?vue&type=script&lang=js"
import style0 from "./WaterworksWriteBody.vue?vue&type=style&index=0&id=5aa68108&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa68108",
  null
  
)

export default component.exports